import { Controller } from "react-hook-form";
import CustomMultiSelect from "../../CustomMultiSelect";
import "./style.css";

interface IProps {
  name: string;
  control: any;
  options: { label: string; value: string }[];
  className?: string;
  containerClassName?: string;
  label: string;
  showClear?: boolean;
  showSearch?: boolean;
  error?: string;
  disabled?: boolean;
  loading?: boolean;
}

const ControlledMultiSelect = ({
  name,
  control,
  options,
  className = "",
  containerClassName = "",
  label,
  showClear,
  showSearch,
  error,
  disabled,
  loading,
}: IProps) => {
  return (
    <div className={`controlled-multiselect-container ${containerClassName || ""}`}>
      <label htmlFor={name} className={`controlled-multiselect-label ${error ? "error" : ""}`}>
        {label}
      </label>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <CustomMultiSelect
            value={value || []}
            onChange={onChange}
            options={options}
            showClear={showClear}
            showSearch={showSearch}
            className={`controlled-multiselect-input ${className || ""} ${error ? "error" : ""}`}
            disabled={disabled || loading}
          />
        )}
      />
      {error && <small className="controlled-multiselect-error">{error}</small>}
    </div>
  );
};

export default ControlledMultiSelect;
